<template>
  <div class="app-contract-summary-failure">
    <div v-if="this.showExpired">
      <slot :name="`ceExpired${process}`"></slot>
    </div>
    <div v-else-if="this.showAlready">
      <slot :name="`ceAlreadyConfirmed${process}`"></slot>
    </div>
    <div v-else-if="this.showFail">
      <dyn-slot :slot-data="{errorMsg: this.errorMsg}"><slot :name="`ceError${process}`"></slot></dyn-slot>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'ContractSummaryFailure',
  props: {
    alreadyConfirmed: {
      type: Boolean,
      default: false
    }
  },
  mounted () {
    this.stopLoader()
  },
  mixins: [
  ],
  computed: {
    ...mapGetters('contractSummary', {
      expired: 'expired',
      errorMessage: 'errorMessage',
      showCSError: 'showCSError',
      expiredLinkUrl: 'expiredLinkUrl',
      alreadyLinkUrl: 'alreadyLinkUrl',
      process: 'process'
    }),
    showExpired: function () {
      return (this.expired && !this.alreadyConfirmed)
    },
    showAlready: function () {
      return this.alreadyConfirmed
    },
    showFail: function () {
      return !this.alreadyConfirmed && !this.showExpired
    },
    errorMsg: function () {
      if (this.showCSError === true) {
        return this.$slots.errorMsgNoProcessId ? this.$slots.errorMsgNoProcessId[0].text : 'Der Link ist ungültig. Schau mal, ob sich ein Fehler im Link eingeschlichen hat. (Fehler: CS1)'
      }
      return this.errorMessage
    }
  }
}
</script>
